module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step1a_Image6i.65b4808e.jpg";